
import { Brain, HardDrive, Puzzle, Search, Calculator, List, Type, Gamepad, Clock, Target, Lightbulb, Activity, Dices, Gauge, Grid, LayoutGrid } from "lucide-react";
import React from "react";
import { GameType } from "@/components/GameCard";

export const games: GameType[] = [
  {
    id: "memory-match",
    name: "Memory Match",
    description: "Sharpen your memory by matching pairs of cards",
    icon: <HardDrive size={24} />
  },
  {
    id: "simon-says",
    name: "Simon Says",
    description: "Remember and repeat increasingly complex sequences",
    icon: <Brain size={24} />
  },
  {
    id: "quick-math",
    name: "Quick Math Challenge",
    description: "Strengthen your mental arithmetic skills",
    icon: <Calculator size={24} />
  },
  {
    id: "spot-difference",
    name: "Spot the Difference",
    description: "Train your visual attention to detail",
    icon: <Search size={24} />
  },
  {
    id: "word-search",
    name: "Word Search",
    description: "Find hidden words to build your focus",
    icon: <Search size={24} />
  },
  {
    id: "stroop-test",
    name: "Stroop Test",
    description: "Challenge your cognitive flexibility with conflicting info",
    icon: <Type size={24} />
  },
  {
    id: "whack-a-mole",
    name: "Whack-a-Mole",
    description: "Test your reflexes and selective attention",
    icon: <Activity size={24} />
  },
  {
    id: "tower-hanoi",
    name: "Tower of Hanoi",
    description: "Improve your planning and problem-solving abilities",
    icon: <Target size={24} />
  },
  {
    id: "number-sequences",
    name: "Number Sequences",
    description: "Find patterns in complex number series",
    icon: <List size={24} />
  },
  {
    id: "anagram-solver",
    name: "Anagram Solver",
    description: "Rearrange letters to form meaningful words",
    icon: <Type size={24} />
  },
  {
    id: "maze-solver",
    name: "Maze Solver",
    description: "Navigate through increasingly complex labyrinths",
    icon: <Gamepad size={24} />
  },
  {
    id: "reaction-test",
    name: "Reaction Test",
    description: "Test your reflexes by clicking targets as they appear",
    icon: <Gauge size={24} />
  },
  {
    id: "pattern-memory",
    name: "Pattern Memory",
    description: "Memorize and recreate visual patterns",
    icon: <Puzzle size={24} />
  },
  {
    id: "n-back",
    name: "N-Back Challenge",
    description: "Test your working memory by remembering items N steps back",
    icon: <Brain size={24} />
  },
  {
    id: "word-pairs",
    name: "Word Pairs",
    description: "Memorize and recall associated word pairs",
    icon: <Type size={24} />
  },
  {
    id: "mental-rotation",
    name: "Mental Rotation",
    description: "Identify rotated versions of shapes to improve spatial skills",
    icon: <Dices size={24} />
  },
  {
    id: "crossword",
    name: "Crossword Puzzle",
    description: "Solve crossword puzzles to enhance vocabulary and lateral thinking",
    icon: <Grid size={24} />
  },
  {
    id: "sliding-puzzle",
    name: "Sliding Puzzle",
    description: "Rearrange scrambled tiles to form a complete picture",
    icon: <LayoutGrid size={24} />
  },
  {
    id: "sudoku",
    name: "Sudoku",
    description: "Exercise your logical thinking with number puzzles",
    icon: <Puzzle size={24} />
  },
  {
    id: "nonograms",
    name: "Nonograms",
    description: "Solve picture logic puzzles using numbers as clues",
    icon: <Puzzle size={24} />
  },
  {
    id: "word-chain",
    name: "Word Chain",
    description: "Connect words using the last and first letters",
    icon: <Type size={24} />
  },
  {
    id: "dual-n-back",
    name: "Dual N-Back",
    description: "Advanced memory training with multiple stimuli",
    icon: <Brain size={24} />
  },
  {
    id: "task-switching",
    name: "Task Switching",
    description: "Build mental flexibility by rapidly changing focus",
    icon: <Activity size={24} />
  },
  {
    id: "sequence-recall",
    name: "Sequence Recall",
    description: "Test your working memory with pattern recognition",
    icon: <List size={24} />
  }
];
